import React from "react";
import "./Footer.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  // faYoutube,
  faFacebook,
  faInstagram,
  faWhatsapp,
} from "@fortawesome/free-brands-svg-icons";
import { faEnvelope } from "@fortawesome/free-regular-svg-icons";

export default function Footer() {
  return (
    <div className="footer">
      <div>
        <div className="footer-content">
          <div className="sub">
            <div className="footer_logo">OROCHIMEII 3D</div>
            <div className="text_center">
              <p>
                <b>Empresa</b>
              </p>
              <p>
                Nuestra misión es dar vida a tus ideas y proyectos a través de
                la innovación y la calidad.
              </p>
            </div>
            <div>
              <p>
                <b>Servicios</b>
              </p>
              <p>Impresión 3D</p>
              <p>Diseño en general</p>
              <p>Modelado tridimensional</p>
              <p>Desarrollo de paginas web</p>
            </div>
            <div>
              <p>
                <b>Contacto</b>
              </p>
              <p>
                <FontAwesomeIcon icon={faWhatsapp} size="1x" /> +543886856816
              </p>
              <p>
                <FontAwesomeIcon icon={faEnvelope} size="1x" />{" "}
                orochimeii3d@gmail.com
              </p>
            </div>
            <div>
              <p>
                <b>Redes sociales</b>
              </p>
              <div>
                <p>
                  <FontAwesomeIcon icon={faFacebook} size="1x" /> Orochimeii 3D
                </p>
                <p>
                  <FontAwesomeIcon icon={faInstagram} size="1x" /> orochimeii_3D
                </p>
                {/* <p>
                  <FontAwesomeIcon icon={faYoutube} size="1x" /> Orochimeii 3D
                </p> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
